import { render } from "./main-product-sidebar-details.vue?vue&type=template&id=5b0610f6"
import script from "./main-product-sidebar-details.vue?vue&type=script&lang=js"
export * from "./main-product-sidebar-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__